import { render, staticRenderFns } from "./img-upload.vue?vue&type=template&id=b2a8e868&"
import script from "./img-upload.vue?vue&type=script&lang=js&"
export * from "./img-upload.vue?vue&type=script&lang=js&"
import style0 from "./img-upload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports